// Injected at build time by vite.config.ts from git commit hash
export const APP_VERSION: string = __APP_VERSION__;
export const BUILD_TIME: string = __BUILD_TIME__;
